import React, { useState, useEffect, useRef } from 'react';
import { Typography, Box, Button, useMediaQuery, useTheme, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { EditMode } from './types';
import { StepButtonBar } from './StepButtonBar';
import OurLawInfo from './OurLawInfo';

const PRIMARY = '#c4122f';

interface EditStep1ChoiceProps {
    onModeSelect: (mode: EditMode) => void;
    onCancel: () => void;
    currentEditMode?: EditMode;
    currentStepName: string;
    ourLawInfo:any;
    setOurLawInfo:(any)=>void;
}

const EditStep1Choice = ({ onModeSelect, onCancel, currentEditMode,currentStepName,ourLawInfo,setOurLawInfo }: EditStep1ChoiceProps) => {
    const [selectedMode, setSelectedMode] = useState<EditMode>(currentEditMode ?? null);
    const prevModeRef = useRef<EditMode>(currentEditMode ?? null);
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

    // Sync selectedMode with currentEditMode (when returning to choice screen)
    useEffect(() => {
        setSelectedMode(currentEditMode ?? null);
        prevModeRef.current = currentEditMode ?? null;
    }, [currentEditMode]);

    const handleNext = () => {
        if (selectedMode) {
            onModeSelect(selectedMode);
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <Box style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                    <Button
                        variant="outlined"
                        onClick={onCancel}
                        style={{ borderColor: PRIMARY, color: PRIMARY }}
                    >
                        {formatMessage({ id: 'form.cancel', defaultMessage: 'Cancel' })}
                    </Button>
                </Box>

            </Box>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    gap: '10px',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'stretch',
                }}
            >
                <div
                    style={{
                        width: isMobile ? '100%' : 'calc(50% - 5px)',
                        flexShrink: 0,
                        padding: paperPadding,
                        backgroundColor: '#f7f0f1',
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: "350px"
                    }}
                >

                    <Box style={{ maxWidth: '320px', width: '100%' }}>
                        <Grid container spacing={3} justifyContent="flex-start">
                            <Grid
                                item
                                xs={12}
                                style={{ display: 'flex', justifyContent: 'center' }}
                            >
                                <Button
                                    variant={selectedMode === 'add' ? 'contained' : 'outlined'}
                                    onClick={() => setSelectedMode('add')}
                                     style={{
                      padding: isMobile ? '18px 24px' : '22px 32px',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: 700,
                      color: selectedMode === 'add' ? '#fff' : PRIMARY,
                      background: selectedMode === 'add' ? PRIMARY : 'transparent',
                      width: '100%',
                      minWidth: '230px',
                      borderRadius: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'all 0.2s ease',
                      border: `2px solid ${PRIMARY}`,
                    }}
                                >
                                    {formatMessage({
                                        id: 'law-portal.manage.law-list.add-law',
                                        defaultMessage: 'Add Law',
                                    })}
                                </Button>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                style={{ display: 'flex', justifyContent: 'center' }}
                            >
                                <Button
                                    variant={selectedMode === 'delete' ? 'contained' : 'outlined'}
                                    onClick={() => setSelectedMode('delete')}
                                      style={{
                      padding: isMobile ? '18px 24px' : '22px 32px',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: 700,
                      color: selectedMode === 'delete' ? '#fff' : PRIMARY,
                      background: selectedMode === 'delete' ? PRIMARY : 'transparent',
                      width: '100%',
                      minWidth: '230px',
                      borderRadius: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'all 0.2s ease',
                      border: `2px solid ${PRIMARY}`,
                    }}
                                >
                                    {formatMessage({
                                        id: 'lawportal.our-law.Delete-law',
                                        defaultMessage: 'Delete Law',
                                    })}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </div>

                <OurLawInfo ourLawStepInfo={ourLawInfo} currentStepName={currentStepName} onUpdate={setOurLawInfo} />
            </div>

            <Box>
                <StepButtonBar
                    onCancel={onCancel}
                    onBack={() => { }}
                    onNext={handleNext}
                    nextLabel="form.next"
                    nextDisabled={selectedMode === null}
                    formatMessage={formatMessage}
                    showBack={false}
                />
            </Box>
        </div>
    );
};

export default EditStep1Choice;
